import React, { useState, useEffect } from 'react';

const GA_ID = 'G-TX79C4XHGV';
const CONSENT_KEY = 'orca-cookie-consent';

function loadGoogleAnalytics() {
  if (window.gtagLoaded) return;
  window.gtagLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try { stored = localStorage.getItem(CONSENT_KEY); } catch (e) { /* private mode etc. */ }

    if (stored === 'accepted') {
      loadGoogleAnalytics();
    } else if (stored !== 'rejected') {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try { localStorage.setItem(CONSENT_KEY, 'accepted'); } catch (e) {}
    loadGoogleAnalytics();
    setVisible(false);
  };

  const reject = () => {
    try { localStorage.setItem(CONSENT_KEY, 'rejected'); } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <p>
        We use cookies to understand how visitors use this site (Google Analytics). No cookies
        are set until you accept. See our <a href="/privacy-policy">Privacy Policy</a> for details.
      </p>
      <div className="cookie-banner-actions">
        <button type="button" className="cookie-reject" onClick={reject}>Reject</button>
        <button type="button" className="cookie-accept" onClick={accept}>Accept</button>
      </div>
    </div>
  );
}

export default CookieConsent;
